import {
  initialState,
  Actions,
  State,
  REORDER_CATEGORY_POSTS,
  REORDER_CATEGORY_POSTS_SUCCESS,
  REORDER_CATEGORY_POSTS_ERROR,
} from "../../types/category/reorder-category-posts";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case REORDER_CATEGORY_POSTS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case REORDER_CATEGORY_POSTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case REORDER_CATEGORY_POSTS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
